import { get } from "lodash"
import { makeStyles } from "@material-ui/core/styles"
import Avatar from "@material-ui/core/Avatar"
import Box from "@material-ui/core/Box"
import CommaPrice from "src/features/Utils/CommaPrice"
import Grid from "@material-ui/core/Grid"
import React from "react"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import EditIcon from "@material-ui/icons/Edit"
import CloseIcon from "@material-ui/icons/Close"
import QuantityModal from "./QuantityModal"

import NoImage from "src/assets/no-image.jpg"

const useStyles = makeStyles((theme) => ({
  avatar: { width: 67, height: 67 },
}))

export default ({ item, update, remove, inCart }) => {
  const classes = useStyles()

  return (
    <Box bgcolor="white" p={2} mb={2}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={1}>
          <Avatar
            src={get(item, "cover_img") || NoImage}
            variant="rounded"
            className={classes.avatar}
          />
        </Grid>
        <Grid item xs={3}>
          <Box>{get(item, "presentation.search_name")}</Box>
          <Box color="text.secondary">
            {get(
              item,
              "presentation.registration_number.register_as.generics",
              []
            )
              .map((item) => item.name + " " + item.strength)
              .join(", ")}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box>{`${item.multiplier} ${item.presentation.presentation_name.name} x ${item.presentation.quantity} ${item.presentation.presentation_unit.name} / ${item.container.name}`}</Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Typography color={get(item, "is_promo") ? "primary" : "initial"}>
              {CommaPrice(
                get(item, "is_promo")
                  ? get(item, "promo_price")
                  : get(item, "price")
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Box>{get(item, "amount")}X</Box>
        </Grid>
        <Grid item xs={1}>
          <Box>
            {CommaPrice(
              get(item, "is_promo")
                ? get(item, "promo_price") * get(item, "amount")
                : get(item, "price") * get(item, "amount")
            )}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box>
            <QuantityModal
              onConfirm={(amount) => update(amount)}
              defaultQty={get(inCart, "amount")}
            >
              <IconButton>
                <EditIcon />
              </IconButton>
            </QuantityModal>
            <IconButton onClick={remove}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
